export default __webpack_public_path__ + "static/media/pexels-tyler-lastovich-719399.ff2edd9a.jpg";